module.exports = __webpack_public_path__ + "img/selected0-min.9feacf16.png";